const TextInput = {
  defaultProps: {
    size: 'md',
  },
  styles: (theme, _params, { borderColor } = {}) => ({
    input: {
      ...(_params.variant === 'unstyled'
        ? {}
        : {
            borderColor: theme.colors.gray[borderColor || 3],
            boxShadow: '0px 2px 12px 0px rgba(29, 38, 58, 0.08)',
            ':focus': {
              borderColor: theme.colors.primary[6],
            },
          }),
    },
  }),
};

export default TextInput;
